import apiConnector from '@/epersonam/apiConnector';
import errorManager from '@/rollbar.js';

function setListener() {
  $('.modal #guest_activity_domestic_activities_config_id_modal').on('change', (event) => {
    $('#guest_activity_domestic_motivation_modal').val('').trigger('change');

    const activityId = parseInt(event.target.value);

    $('.modal #guest_activity_domestic_motivation_modal').select2({
      data: [],
      theme: 'bootstrap',
      include_blank: false,
      allowClear: true,
      minimumResultsForSearch: -1,
      placeholder: 'Seleziona una motivazione',
    });

    Loader.show();
    apiConnector()
      .get('/it/activities_configs/get_motivations_from_activity.json', {
        params: { activity_id: activityId },
      })
      .then(({ data }) => {
        const result = [];

        console.log('Fetched', data, result);

        data.forEach((activityConfig) => {
          if (activityConfig.motivation) {
            for (let m in activityConfig.motivation) {
              result.push({
                id: activityConfig.motivation[m].cod,
                text: activityConfig.motivation[m].desc,
              });
            }
            console.log(result);
          }
        });

        $('.modal #guest_activity_domestic_motivation_modal').empty().select2({
          data: result,
          theme: 'bootstrap',
          include_blank: false,
          allowClear: true,
          minimumResultsForSearch: -1,
          placeholder: 'Seleziona una motivazione',
        });
      })
      .catch((err) => {
        console.error('qualcosa non ha funzionato', err);
      })
      .finally(() => {
        Loader.hide();
      });
  });
}

const init = () => {
  try {
    setListener();
  } catch (e) {
    errorManager(e);
  }
};

window.ModalForAgenda = {
  init: init,
};
